import React, { useRef } from 'react';
import { useComponentDidMount } from './useComponentDidMount';
import { useComponentWillUnmount } from './useComponentWillUnmount';

const onOverlayTouchEvent = (event: TouchEvent) => {
    event?.stopPropagation();
};

export const useStopEventBackgroundPropagation = (): React.RefObject<any> => {
    const ref = useRef(null);

    useComponentDidMount(() => {
        ref?.current?.addEventListener('touchmove', onOverlayTouchEvent);
        ref?.current?.addEventListener('touchstart', onOverlayTouchEvent);
        ref?.current?.addEventListener('touchend', onOverlayTouchEvent);
    });

    useComponentWillUnmount(() => {
        ref?.current?.removeEventListener('touchmove', onOverlayTouchEvent);
        ref?.current?.removeEventListener('touchstart', onOverlayTouchEvent);
        ref?.current?.removeEventListener('touchend', onOverlayTouchEvent);
    });

    return ref;
};
